export default class ZoomModal {
    constructor() {
        this.$zoom = null;
        this.$inner = null;
        this._pinchBound = false;
        this._scale = 1;
        this._translateX = 0;
        this._translateY = 0;
        this._startDist = 0;
        this._startScale = 1;
        this._startX = 0;
        this._startY = 0;
        this._startTranslateX = 0;
        this._startTranslateY = 0;
        this._mode = null;

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.init());
        } else {
            this.init();
        }
    }

    init() {
        this.addZoom();
    }

    addZoom() {
        const $openArray = [...document.querySelectorAll('.c-zoom__open')],
            $zoom = document.querySelector('.c-zoom'),
            $inner = $zoom ? $zoom.querySelector('.c-zoom__inner') : null,
            $close = $zoom ? $zoom.querySelector('.c-zoom__close') : null;

        if (!$zoom || !$inner || !$close || $openArray.length === 0) return;

        this.$zoom = $zoom;
        this.$inner = $inner;
        this._bindPinch();

        $openArray.forEach(($open) => {
            $open.addEventListener('click', () => {
                $inner.innerHTML = '';
                const $clone = $open.children[0].cloneNode(true);
                $inner.appendChild($clone);
                $zoom.classList.add('-active');
                this._resetTransform();
            });
        });

        $close.addEventListener('click', () => {
            $zoom.classList.remove('-active');
            this._resetTransform();
        });

        $zoom.addEventListener('transitionend', (e) => {
            if (!e.currentTarget.classList.contains('-active')) {
                $inner.innerHTML = '';
            }
        });
    }

    _bindPinch() {
        if (this._pinchBound || !this.$inner) return;
        this._pinchBound = true;

        this.$inner.addEventListener('touchstart', (e) => this._onTouchStart(e), { passive: false });
        this.$inner.addEventListener('touchmove', (e) => this._onTouchMove(e), { passive: false });
        this.$inner.addEventListener('touchend', (e) => this._onTouchEnd(e), { passive: false });
        this.$inner.addEventListener('touchcancel', (e) => this._onTouchEnd(e), { passive: false });
    }

    _onTouchStart(e) {
        if (!this.$zoom || !this.$zoom.classList.contains('-active')) return;
        if (e.touches.length === 2) {
            this._mode = 'pinch';
            this._startDist = this._getDistance(e.touches[0], e.touches[1]);
            this._startScale = this._scale;
        } else if (e.touches.length === 1 && this._scale > 1) {
            this._mode = 'pan';
            this._startX = e.touches[0].clientX;
            this._startY = e.touches[0].clientY;
            this._startTranslateX = this._translateX;
            this._startTranslateY = this._translateY;
        }
    }

    _onTouchMove(e) {
        if (!this.$zoom || !this.$zoom.classList.contains('-active')) return;
        if (this._mode === 'pinch' && e.touches.length === 2) {
            e.preventDefault();
            const dist = this._getDistance(e.touches[0], e.touches[1]);
            const nextScale = this._startScale * (dist / this._startDist);
            this._scale = this._clamp(nextScale, 1, 3);
            this._applyTransform();
        } else if (this._mode === 'pan' && e.touches.length === 1) {
            e.preventDefault();
            this._translateX = this._startTranslateX + (e.touches[0].clientX - this._startX);
            this._translateY = this._startTranslateY + (e.touches[0].clientY - this._startY);
            this._applyTransform();
        }
    }

    _onTouchEnd(e) {
        if (e.touches.length === 0) {
            this._mode = null;
        } else if (e.touches.length === 1 && this._mode === 'pinch' && this._scale > 1) {
            this._mode = 'pan';
            this._startX = e.touches[0].clientX;
            this._startY = e.touches[0].clientY;
            this._startTranslateX = this._translateX;
            this._startTranslateY = this._translateY;
        }
    }

    _applyTransform() {
        if (!this.$inner) return;
        this.$inner.style.transform = `translate(${this._translateX}px, ${this._translateY}px) scale(${this._scale})`;
    }

    _resetTransform() {
        this._scale = 1;
        this._translateX = 0;
        this._translateY = 0;
        if (this.$inner) {
            this.$inner.style.transform = '';
        }
    }

    _getDistance(t1, t2) {
        const dx = t1.clientX - t2.clientX;
        const dy = t1.clientY - t2.clientY;
        return Math.hypot(dx, dy);
    }

    _clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
    }
}
